import { Button } from '@chakra-ui/react'

import { useTranslationsContext } from 'BrokerTsLib/src/context/TranslationsContext'
import { Search } from '../../images/Search'

interface SearchButtonProps {
  isOpen: boolean
  toggleOpen?: () => void
}

export const SearchButton = ({ isOpen, toggleOpen }: SearchButtonProps) => {

  const { translate } = useTranslationsContext()

  return (
    <Button onClick={toggleOpen}>
      <Search />
      {isOpen ? translate('ui.hideSearch', 'Skrýt vyhledávání') : translate('ui.search', 'Vyhledávání')}
    </Button>
  )
}
